<template>
    <div class="py-4">
        <header>
            <div class="container-fluid">
                <div class="pb-4">
                    <div class="row align-items-end">
                        <div class="col-sm col-12">
                            <h1 class="h2 ls-tight">Tablero</h1>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main>
            <div class="container-fluid">
                <div class="vstack gap-4">
                    <div class="row">
                        <div class="col-lg-7 mb-3">
                            <div class="card">
                                <div class="card-header bg-white px-1">
                                    <div class="row justify-content-between align-items-center">
                                        <div class="col-lg-6"><h2 class="subtitle mb-0">Usuarios</h2></div>
                                        <div class="col-lg-6 d-flex justify-content-end">
                                            <div class="d-flex">
                                                <v-select v-model="form.year"
                                                    :items="years"
                                                    hide-details
                                                    @change="USERS"
                                                    dense
                                                    class="form-control form-control-sm" style="width: 85px;">
                                                    <template v-slot:selection="{item}">
                                                        <div class="v-select__selection v-select__selection--comma">
                                                            {{ item }}
                                                        </div>
                                                    </template>
                                                </v-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div style="height: 275px;" class="justify-content-center align-items-center" :class="loading ? 'd-none' : 'd-flex'">
                                        <div class="spinner-grow text-dark" role="status">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                    <line-chart :chartData="chartDataUsers" style="height: 275px;" v-show="loading"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-5 mb-3">
                            <div class="card">
                                <div class="card-header border-bottom-0 bg-white d-flex align-items-center" style="height: 56px;">
                                    <h2 class="subtitle mb-0">Ultimos Usuarios Registrados</h2>
                                </div>
                                <div class="card-body" style="height: 315px;">
                                    <div class="list-group gap-4">
                                        <div class="list-group-item d-flex align-items-center border rounded" v-for="(item, key) in data.lasts" :key="key">
                                            <div class="me-4">
                                                <div class="icon icon-shape bg-dark text-white text-lg rounded-circle">
                                                    <i class="fa-solid fa-user"></i>
                                                </div>
                                            </div>
                                            <div class="flex-fill">
                                                <a href="#" class="d-block h6 font-semibold mb-1 text-decoration-none text-dark">{{ item.type }}{{ item.id }}</a>
                                                <span class="d-block text-sm text-muted">{{ item.name }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 mb-3">
                            <div class="card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col">
                                            <span class="h6 font-semibold text-muted text-sm d-block mb-2">Total Usuarios Registrados</span>
                                            <span class="h3 font-bold mb-0">{{ data.total }}</span>
                                        </div>
                                        <div class="col-auto">
                                            <div class="icon icon-shape bg-primary text-white text-lg rounded-circle">
                                                <i class="fa-solid fa-users"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 mb-3">
                            <div class="card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col">
                                            <span class="h6 font-semibold text-muted text-sm d-block mb-2">Total Usuarios Activos</span>
                                            <span class="h3 font-bold mb-0">{{ data.enabled }}</span>
                                        </div>
                                        <div class="col-auto">
                                            <div class="icon icon-shape bg-success text-white text-lg rounded-circle">
                                                <i class="fa-solid fa-user-tag"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 mb-3">
                            <div class="card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col">
                                            <span class="h6 font-semibold text-muted text-sm d-block mb-2">Total Usuarios Registrados del Mes</span>
                                            <span class="h3 font-bold mb-0">{{ data.months }}</span>
                                        </div>
                                        <div class="col-auto">
                                            <div class="icon icon-shape bg-orange text-white text-lg rounded-circle">
                                                <i class="fa-solid fa-user-clock"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 mb-3">
                            <div class="card">
                                <div class="card-header bg-white px-1">
                                    <div class="row justify-content-between align-items-center">
                                        <div class="col-lg-6"><h2 class="subtitle mb-0">Paquetes entregados</h2></div>
                                        <div class="col-lg-6 d-flex justify-content-end">
                                            <div class="d-flex">
                                                <v-select v-model="form.year_package"
                                                    :items="years"
                                                    hide-details
                                                    @change="PACKAGES"
                                                    dense
                                                    class="form-control form-control-sm" style="width: 85px;">
                                                    <template v-slot:selection="{item}">
                                                        <div class="v-select__selection v-select__selection--comma">
                                                            {{ item }}
                                                        </div>
                                                    </template>
                                                </v-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div style="height: 275px;" class="justify-content-center align-items-center" :class="loading_packages ? 'd-none' : 'd-flex'">
                                        <div class="spinner-grow text-dark" role="status">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                    <line-chart :chartData="chartDataPackages" style="height: 275px;" v-show="loading_packages"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
import LineChart from '../components/charts/LineChart'
import BarChart from '../components/charts/BarChart'
export default {
    components: { LineChart, BarChart },
    data(){
        var now = new Date()
        return{
            data: {
                total: 0,
                enabled: 0,
                months: 0,
                lasts: []
            },
            chartDataUsers: {
                labels: []
            },
            chartDataPackages: {
                labels: []
            },
            form: {
                year: now.getFullYear(),
                year_package: now.getFullYear(),
            },
            loading: false,
            loading_packages: false,
        }
    },
    computed: {
        years: function(){
            const max = new Date().getFullYear()
            const min = max - 100
            const years = []
            for (let i = max; i >= min; i--) {
                years.push(i)
            }
            return years
        }
    },
    mounted(){
        this.USERS()
        this.USERS_TOTAL()
        this.USERS_ENABLED()
        this.USERS_MONTHS()
        this.USERS_LASTS()
        this.PACKAGES()
    },
    methods:{
        USERS: function(){
            let vue = this
            vue.loading = false
            axios({url: '/dashboard/users?year=' + vue.form.year, method: 'GET' })
            .then((resp) => {
                vue.chartDataUsers = {
                    labels: resp.data.labels,
                    datasets: [
                        {
                            label: '',
                            data: resp.data.data,
                            fill: false,
                            borderColor: '#1F68B3',
                            pointBackgroundColor: '#1F68B3',
                            borderWidth: 3,
                            pointRadius: 4,
                            pointHoverRadius: 6,
                            pointHoverBackgroundColor: '#1F68B3',
                        }
                    ]
                }
            })
            .finally((resp) => {
                vue.loading = true
            })
        },
        USERS_TOTAL: function(){
            let vue = this
            axios({url: '/dashboard/users/total', method: 'GET' })
            .then((resp) => {
                vue.data.total = resp.data
            })
        },
        USERS_ENABLED: function(){
            let vue = this
            axios({url: '/dashboard/users/enabled', method: 'GET' })
            .then((resp) => {
                vue.data.enabled = resp.data
            })
        },
        USERS_MONTHS: function(){
            let vue = this
            axios({url: '/dashboard/users/months', method: 'GET' })
            .then((resp) => {
                vue.data.months = resp.data
            })
        },
        USERS_LASTS: function(){
            let vue = this
            axios({url: '/dashboard/users/lasts', method: 'GET' })
            .then((resp) => {
                vue.data.lasts = resp.data
            })
        },
        PACKAGES: function(){
            let vue = this
            vue.loading_packages = false
            axios({url: '/dashboard/packages?year=' + vue.form.year_package, method: 'GET' })
            .then((resp) => {
                vue.chartDataPackages = {
                    labels: resp.data.labels,
                    datasets: [
                        {
                            label: '',
                            data: resp.data.data,
                            fill: false,
                            borderColor: '#EE2E24',
                            pointBackgroundColor: '#EE2E24',
                            borderWidth: 3,
                            pointRadius: 4,
                            pointHoverRadius: 6,
                            pointHoverBackgroundColor: '#EE2E24',
                        }
                    ]
                }
            })
            .finally((resp) => {
                vue.loading_packages = true
            })
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/Dashboard.vue